/* eslint-disable import/first */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import Link from '@material-ui/core/Link';
import { FormattedMessage, useIntl } from 'react-intl';
import { BsChevronDown } from '@react-icons/all-files/bs/BsChevronDown';

// import { selectDesktop } = Slices.appSlice;
// import { selectStoreEntities } = Slices.storeSlice;
// import { selectDefaultAddress } = Slices.addressSlice;

import { getOrderModeLink } from 'spwa-ui-library/esm/utils/helper';
import AddressPin from '../Icons/AddressPin';
import css from './index.module.scss';
import Classnames from 'classnames';
import AddressDropdown from '../Icons/AddressDropdown';

const { selectDesktop } = Slices.appSlice;
const { selectStoreEntities } = Slices.storeSlice;
const { selectDefaultAddress } = Slices.addressSlice;

export default function AddressSelector() {
  const location = useLocation();
  const intl = useIntl();
  const navigate = useNavigate();
  const defaultAddress = useSelector(selectDefaultAddress);
  const mainAddress = useSelector((state) => state.address);
  const storeList = useSelector(selectStoreEntities);
  const isDesktop = useSelector(selectDesktop);
  const [selectedStore, setSelectedStore] = React.useState({});

  const [selectedAddress, setSelectedAddress] = useState(
    Object.entries(defaultAddress).length ? defaultAddress : null
  );
  // const modeRoute = {
  //   DELIVERY: 'delivery',
  //   STORE: 'pickup',
  //   CARHOP: 'carhop',
  //   DINEIN: 'dinein',
  //   DRIVETHRU: 'drivethru',
  // };

  let modeName = selectedAddress?.addressSubType.toLowerCase() || 'delivery';
  if (modeName === 'delivery' && mainAddress?.data?.info && mainAddress?.data?.info?.length === 0) {
    modeName = 'addAddress';
  }

  const getOrderModeURL = getOrderModeLink({
    path: location.pathname,
    modeType: modeName?.toLowerCase(),
    isDesktop,
    locale: intl.locale,
    queryParams: location?.search,
  });

  const handleClick = useCallback(
    (e) => {
      // navigate('/delivery');
      e.preventDefault();
      let modeName = defaultAddress?.addressSubType?.toLowerCase() || 'delivery';
      if (
        modeName === 'delivery' &&
        mainAddress?.data?.info &&
        mainAddress?.data?.info?.length === 0
      ) {
        modeName = 'addAddress';
      }
      let modeURL = getOrderModeLink({
        path: location.pathname,
        modeType: modeName?.toLowerCase(),
        isDesktop,
        locale: intl.locale,
        queryParams: location?.search,
      });
      navigate(modeURL);
    },
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    [defaultAddress, defaultAddress?.addressSubType]
  );

  const addressString = `address_${intl.locale}`;

  useEffect(() => {
    Object.values(storeList || {}).every((val) => {
      if (val.storeId === selectedAddress?.storeId) {
        setSelectedStore(val);
        return false;
      }
      return true;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAddress]);

  useEffect(() => {
    setSelectedAddress(Object.entries(defaultAddress).length ? defaultAddress : null);
  }, [defaultAddress]);

  let titleLabel = '';
  let prefix = '';
  let tag = '';
  let description = '';
  if (selectedAddress) {
    if (selectedAddress.addressSubType === 'STORE') {
      prefix = <FormattedMessage id="order_mode_pickup" defaultMessage="PICKUP FROM" />;
      tag = selectedAddress.bldgName;
      description = selectedStore[addressString];
    } else if (selectedAddress.addressSubType === 'CARHOP') {
      prefix = <FormattedMessage id="order_mode_carhop" defaultMessage="CARHOP FROM" />;
      tag = selectedAddress.bldgName;
      description = selectedStore[addressString];
    } else if (selectedAddress.addressSubType === 'DINEIN') {
      prefix = <FormattedMessage id="order_mode_dinein" defaultMessage="DINE-IN AT" />;
      tag = selectedAddress.bldgName;
      description = selectedStore[addressString];
    } else if (selectedAddress.addressSubType === 'DRIVETHRU') {
      prefix = <FormattedMessage id="order_mode_drivethru" defaultMessage="DRIVE-THRU AT" />;
      tag = selectedAddress.bldgName;
      description = selectedStore[addressString];
    } else {
      prefix = <FormattedMessage id="order_mode_deliver" defaultMessage="DELIVER TO" />;
      tag = selectedAddress.tag;
      description = `${selectedAddress.bldgName}, ${selectedAddress.flatNum}, ${selectedAddress.description}`;
    }

    titleLabel = (
      <React.Fragment>
        <span className={css.titleLabelPrefix}>{prefix}</span>
        <span className={css.addressTag}>
          {selectedAddress.addressSubType === 'DELIVERY' ? (
            <FormattedMessage id={`addressSelector_tag_${tag}`} defaultMessage="DELIVER TO" />
          ) : (
            <>{tag}</>
          )}
        </span>
      </React.Fragment>
    );
  } else {
    titleLabel = <FormattedMessage id="navigation_selectlocation" defaultMessage="SELECT" />;
    description = (
      <FormattedMessage
        id="navigation_pricingmenulist"
        defaultMessage="Get accurate pricing and menu listing"
      />
    );
  }

  return (
    <Link
      className={Classnames(css.root, { [css.active]: titleLabel.props.children })}
      color="inherit"
      underline="none"
      to={getOrderModeURL}
      onClick={handleClick}
    >
      <>
        <div className={css.icon}>
          <AddressPin />
        </div>
        <div className={css.content}>
          <div className={css.titleArea}>
            <h3 className={css.titleLabel}>{titleLabel}</h3>
            {/* Comment below dropdown beacause that was not as per design */}
            {/* <div className={css.selectButton}>
              <span className={css.selectIcon}>
                <BsChevronDown />
              </span>
            </div> */}
            {isDesktop &&
              <div className={css.dropdownBtn}>
                <AddressDropdown />
              </div>
            }
          </div>
          <p className={css.description}>{description}</p>
        </div>
        {!isDesktop &&
          <div className={css.dropdownBtn}>
            <AddressDropdown />
          </div>
        }
      </>
    </Link>
  );
}
